module.exports = __webpack_public_path__ + "static/media/19.b30d6adb.mp3";